var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"value":"tchat","icon":""},on:{"click":_vm.showAbort}},[_c('span',[_vm._v("Abandon")]),_c('pg-icon',{attrs:{"m-d":""}},[_vm._v("i-close-gold")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }